
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";
import { getJsonFromSheet } from '../../Helpers/SheetsHelper';
import ProductList from '../ProductList/ProductList';
import TrimSurfaces from '../TrimSurfaces/TrimSurfaces';

import styles from "./ExteriorUpgrades.module.css";

export default function ExteriorUpgrades() {
    const dispatch = useDispatch();
    const [productId, setSelectProductId] = useState([]);
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    let filter = `prod['id'] == 5382808 || prod['id'] == 5432257`;

    useEffect(() => {
        let product = activeStep?.selection
        if(product != undefined && product != -1)
            setSelectProductId(activeStep?.selection?.id);
    }, [productId]);

    const handleColorSelect = (product) => {
        dispatch(visualizerActions.setSelection(product));
        document.getElementById('chamViz').applyByFilter(product.id, "", function (newSel, currentSelectedSurface) {
            if(this.name == 'Soffit' || this.name == 'Soffit'){
                dispatch(uiActions.setVizLoading(true))
                setSelectProductId(product.id)
                return product.id
            }
        });
    };

    let colors = <ProductList seriesId="8489" thumbSize="250" selectedProductId={productId} filters={filter} handleSelect={handleColorSelect} />;

    return <div className={styles.content}>
        
    <div className={styles.paintHeader}>
        <p>Soffit/Fascia</p>
    </div>
    <div className={styles.schemes}>
        {colors}
    </div>
    {/* <div className={styles.garageShutters}>
        <p>2. Choose apply Surface</p>
        <TrimSurfaces handleSurfaceSelect={handleSurfaceSelect}/>
    </div> */}

</div>

};